import { DemoDictionaryChrome } from "./DemoDictionaryChrome";

export default function DemoDictionaryPage() {
  return <DemoDictionaryChrome variant="hero" />;
}
